import { VirtualAppointmentRow } from './VirtualAppointmentRow';
import type { VirtualAppointmentSummary } from './summary';
import type { VirtualAppointmentLoadStatus } from './types';

export interface VirtualAppointmentRecapListProps {
    summaries: VirtualAppointmentSummary[];
    status: VirtualAppointmentLoadStatus;
    onRetry: () => void;
}

export function VirtualAppointmentRecapList({
    summaries,
    status,
    onRetry
}: VirtualAppointmentRecapListProps) {
    if (status === 'loading') {
        return <div className="h-4 w-3/4 bg-gray-200 rounded animate-pulse" aria-busy="true" />;
    }
    if (status === 'error') {
        return (
            <div className="flex items-center justify-between gap-2 text-sm text-red-500">
                <span>Couldn't load VAs.</span>
                <button
                    type="button"
                    onClick={onRetry}
                    className="text-xs font-semibold text-gray-700 hover:underline"
                >
                    Retry
                </button>
            </div>
        );
    }
    if (summaries.length === 0) {
        return <div className="text-sm text-gray-400 italic">None planned</div>;
    }
    return (
        <div className="flex flex-col divide-y divide-gray-100">
            {summaries.map((summary) => (
                <VirtualAppointmentRow key={summary.key} summary={summary} compact />
            ))}
        </div>
    );
}
